import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { useContent } from "@/context/ContentContext";

const Soon = () => <span className="inline-block px-3 py-1 text-[0.65rem] tracking-[0.25em] uppercase bg-[#C4A47C] text-[#1A1A1A]" data-testid="coming-soon-badge">Kommer snart</span>;
const NOTE = "Kursdato og endelig pris kunngjøres senere. Interesseregistrering er gratis og uforpliktende.";

export const PackageOffer = () => {
  const p = useContent()?.settings?.package;
  if (!p?.enabled) return null;
  return (
    <section className="px-6 md:px-16 lg:px-24 pt-16 pb-28">
      <Reveal className="bg-[#1A1A1A] text-[#FDFBF7] p-10 md:p-14 grid md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-8" data-testid="package-offer">
          <Soon />
          <h2 className="text-4xl md:text-5xl font-medium mt-4" data-testid="package-title">{p.title}</h2>
          <p className="mt-3 text-sm tracking-wide text-[#C4A47C]">4 timer praktisk undervisning · Maks 4 deltakere</p>
          <p className="mt-5 text-[#E5E0D8] leading-relaxed max-w-2xl">{p.text}</p>
        </div>
        <div className="md:col-span-4">
          {p.price && <p className="font-serif-display text-4xl" data-testid="package-price">{p.price} <span className="block text-sm font-sans text-[#C4A47C] mt-1">per deltaker · foreløpig pris</span></p>}
          <Link to="/bestill?type=pakke#forespørsel" className="inline-block mt-6 px-8 py-4 bg-[#C4A47C] text-[#1A1A1A] text-sm hover:bg-[#FDFBF7] transition-colors duration-300" data-testid="package-order-btn">Meld interesse</Link>
          <p className="mt-3 text-xs text-[#E5E0D8]" data-testid="package-note">{NOTE}</p>
        </div>
      </Reveal>
    </section>
  );
};

export const OnlineCourseSoon = () => (
  <section className="px-6 md:px-16 lg:px-24 pb-24">
    <Reveal className="border border-dashed border-[#C4A47C] bg-[#F0EBE1]/50 p-10 md:p-12 flex flex-col items-start gap-6">
      <div data-testid="online-course-soon">
        <Soon />
        <h2 className="text-3xl md:text-4xl font-medium mt-4">Nettkurs i søm – under utvikling. Kommer snart!</h2>
        <p className="mt-3 text-sm text-[#5C5A56]">Meld interesse, så gir vi beskjed når nettkurset er klart. Gratis og uforpliktende.</p>
      </div>
      <Link to="/bestill?type=nettkurs#forespørsel" className="px-8 py-4 bg-[#1A1A1A] text-[#FDFBF7] text-sm hover:bg-[#8C6E48] transition-colors duration-300 whitespace-nowrap" data-testid="online-course-interest-btn">Meld interesse</Link>
    </Reveal>
  </section>
);
